module.exports = __webpack_public_path__ + "assets/facebook.084cffd8.svg";